/**
 * Gera o segmento de rota usado para o `:nome` de `/produto/:ean/:nome`
 * (ver `src/app/pages/produto/produto-routing.module.ts`).
 *
 * O Angular Router 18 trata `( ) ? ; #` e `/` como caracteres reservados que
 * delimitam segmento (abrem outlet secundário/query/fragment), e um `%`
 * isolado quebra o `decodeURIComponent` interno do parser. Nomes de produto
 * com parênteses são comuns em specs (ex.: "iPhone 15 (128GB)") e, sem esse
 * tratamento, fazem a navegação falhar silenciosamente — não existe rota
 * `**` nem assinatura de `NavigationError` hoje que capture o erro.
 *
 * Mantém o slug legível (espaço vira `-`); os caracteres reservados são
 * simplesmente removidos, não escapados — o segmento continua indo pela API
 * de array do Router (`router.navigate([...])` / `[routerLink]="[...]"`),
 * que já cuida do encoding do que sobra.
 *
 * Ref.: issue labinversu/inversu-web#145, task T-286.
 */
export function slugProdutoNome(nome: string | null | undefined): string {
  if (!nome || typeof nome !== 'string') return '';

  return nome
    .replace(/\s+/g, '-')
    .replace(/[()?;#/]/g, '')
    .replace(/%(?![0-9a-fA-F]{2})/g, '');
}
